$(document).ready(function(){
  
  var form = $('.reservationForm');

  form.on('submit', function(e) {
    e.preventDefault();

    var currentForm = $(this);
    var widgetBaseUrl = 'https://bookingpremium.secureholiday.net/';
    var lang = $('html').attr('lang') + '/';
    var arrivalStringDate = currentForm.find('[name="arrivalDate"]').val();
    var departureStringDate = currentForm.find('[name="departureDate"]').val();
    var productType = currentForm.find('[name="productType"]').val();
    
    var arrivalDate = toDate(arrivalStringDate);
    var departureDate = toDate(departureStringDate);
    var reservationUrl = widgetBaseUrl + lang + '8535/search/product-list?dateStart=' + encodeURIComponent(arrivalStringDate) + '&dateEnd=' + encodeURIComponent(departureStringDate) + '&productType=' + encodeURIComponent(productType);

    currentForm.next().find('.error').fadeOut();

    if (arrivalStringDate != '' && departureStringDate != '' && departureDate >= arrivalDate) {
      window.location.href = reservationUrl;
    } else {
      currentForm.next().find('.error').fadeIn().css({
        'display': 'inline-block',
        'background-color': 'rgba(0,0,0,0.5)',
        'padding': '0 1rem'
      });
    }

  });

  function toDate(stringDate) {
    var newDate = stringDate.split('/');
    return new Date(newDate[2], newDate[1] - 1, newDate[0]);
  }

});